import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class TransactionEntityExporter  {
    _originalTypeClassName = "zERP.BO.TransactionEntityExporter";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
TransactionEntityExporter.translate = translateService;
}
this.TransactionEntityExporterKey = null;
this._key = this.TransactionEntityExporterKey = 0; 
}

static translate: TranslateService;
_key: any;
private _TransactionEntityExporterKey:any;
get TransactionEntityExporterKey(): any {
    return this._TransactionEntityExporterKey;
  }
set TransactionEntityExporterKey(value: any) {
    this._TransactionEntityExporterKey = value;
    this._key = value;
  }

static ResolveCollectionItem(collectionName: any,varName: any,item: any): any{if (collectionName == "TRANSACTIONS") {let summary = Joove.Common.cast(item, "Domain.WithheldTaxReportSummary");switch (varName?.toLowerCase()) {case "name":
{
return summary?.AADECode?.Name;}
case "gross_amount":
{
return numeral(summary?.GrossAmount).format("F2");}
case "deduction":
{
return numeral(summary?.DeductionsAmount).format("F2");}
case "tax":
{
return numeral(summary?.TaxAmount).format("F2");}
case "stamp":
{
return numeral(summary?.StampDutyAmount).format("F2");}
case "oga_stamp":
{
let ogaStamp = 0;return numeral(ogaStamp).format("F2");}
case "net_amount":
{
return numeral(summary?.NetAmount).format("F2");}
}}
return "";
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.TransactionEntityExporterKey == null || $this.TransactionEntityExporterKey == 0;
            }


}